import { ValidationError } from "../../errors/validation-error";
import { RealtimeRequest } from "./realtime-request";
import { IRequestById } from "./request-by-id";
import { RealtimeValidator } from "./validators/realtime-validator";
import { RequestByIdValidator } from "./validators/request-by-id-validator";

/**
 * A request for sending real-time notifications to specified users by id.
 */
export class RealtimeRequestById extends RealtimeRequest implements IRequestById {
    recipients: Array<number> = [];

    validate(): void {
        const realtimeFailures = new RealtimeValidator().validate(this);
        const idFailures = new RequestByIdValidator().validate(this);

        if (realtimeFailures.length === 0 && idFailures.length === 0) {
            return;
        } else {
            const failures = realtimeFailures.concat(idFailures);
            throw new ValidationError("RealtimeRequestByUsername is invalid", ...failures);
        }
    }
}
